interface Props {
  name: string;
  errorMessage: string;
  successMessage: string;
}

const StatusInputs = ({ name, errorMessage = '', successMessage = '' }: Props) => {
  return (
    <>
      <input hidden name={`${name}_error_message`} defaultValue={errorMessage} />
      <input hidden name={`${name}_success_message`} defaultValue={successMessage} />
    </>
  );
};

export default StatusInputs;
